import { FC } from 'react';
import { useOptimizelyFeatureFlag } from '@zoopla/optimizely';
import htmlRebrand from './assets/rebrand.html.txt';

/**
 * 12-Mar-21: To help diagnose a production issue with nginx SSI we are
 * directly inlining the html and script snippets here
 */
const TemporaryHardCodedInclude: FC = () => {
    const [_useLiveRamp] = useOptimizelyFeatureFlag('liveramp-consent-banner');

    if (process.env.NODE_ENV !== 'production') {
        return null;
    }

    return _useLiveRamp ? null : (
        <div
            data-testid="consent-banner"
            dangerouslySetInnerHTML={{
                __html: htmlRebrand.replace(
                    '{{segmentID}}',
                    process.env.NEXT_PUBLIC_SEGMENT_ID ?? ''
                )
            }}
        />
    );
};

export default TemporaryHardCodedInclude;
